// removed by extract-text-webpack-plugin
module.exports = {"Backdrop":"Backdrop__Backdrop__eeZpu"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UI/Backdrop/Backdrop.css
// module id = 44
// module chunks = 0